import { render, staticRenderFns } from "./downloadTest.vue?vue&type=template&id=56095f3d"
import script from "./downloadTest.vue?vue&type=script&lang=js"
export * from "./downloadTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports